import type { MailboxInfo } from 'owa-client-types';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isOfflineSyncEnabled } from './isOfflineSyncEnabled';
import { getAccountScopeUserSettings } from 'owa-session-store';

export function isOfflineAttachmentsEnabled(mailboxInfo: MailboxInfo): boolean {
    if (!isOfflineSyncEnabled(mailboxInfo) || !isFeatureEnabled('fwk-offline-attachments')) {
        return false;
    }

    const attachmentsOfflineEnabledWinPolicy =
        isAttachmentsOfflineEnabledWinPolicyEnabled(mailboxInfo);

    return attachmentsOfflineEnabledWinPolicy;
}

export function isAttachmentsOfflineEnabledWinPolicyEnabled(mailboxInfo: MailboxInfo): boolean {
    if (isFeatureEnabled('fwk-offline-attachments-policy')) {
        const accountSettings = getAccountScopeUserSettings(mailboxInfo);
        const policies = accountSettings?.PolicySettings;
        if (policies?.AttachmentsOfflineEnabledWin !== undefined) {
            return policies.AttachmentsOfflineEnabledWin;
        }
        // if the policy is not set, we should return true to allow the
        // feature to work at local level.
        return true;
    }
    // if the feature flag is not enabled, default values is true
    // which allows the feature to work at local level.
    return true;
}
